import { render, staticRenderFns } from "./VendorInventorySalesRankCell.vue?vue&type=template&id=81b825b6"
import script from "./VendorInventorySalesRankCell.vue?vue&type=script&lang=js"
export * from "./VendorInventorySalesRankCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports